module.exports = __webpack_public_path__ + "img/服装-羽绒服.1543b6f2.jpg";